import { render, staticRenderFns } from "./DictamenActionRenderer.vue?vue&type=template&id=7e43134b"
import script from "./DictamenActionRenderer.vue?vue&type=script&lang=js"
export * from "./DictamenActionRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports